  <!-- 资金账号 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug :btndata="BTN_CONFIG" @btnEvent="callBack" @clearBtns="clearBtns" @moreParam="moreParam" @queryBtn_ok="queryBtn_ok" ref="btnList" />
    <!-- 查询列表 -->
    <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="isHaseMore" />

    <!-- 表格 -->
    <table-plug :tableConfig="tableConfig" ref="mytable" :defaulthead="myTableHeard" :totals="totalArr" @rowCallback="rowCallback" @selectChange="handleSelectionChange" @jumpPage="goYdDetails" />
    <!-- 分页 -->
    <paging ref="pags" :pageNum="pageStart" :total="pageCount" :size="pageTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />
    <!-- 整单核销 -->
    <my-dialog :diaWidth="diaWidth" :dialogTitle="dialogTitle" :isShowDialog="isShowDialog" @handleCloseDia="handleCloseDia" @diaCancelBtn="diaCancelBtn" @diaConfirmBtn="diaConfirmBtn">
      <dia-form :diaFormConfig="diaFormConfig" :baseModel="baseModel" ref="diaform" :rules="formRules" :Reset="isShowDialog" />
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <input-plug ref="queryForm" :form-config="baseConfig" :form-data="queryData" :More="true" />
      <!-- 查询列表 -->
    </exportCompoent>
  </div>
</template>
  <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import ImgUpload from "@/components/Modules/ImgUpload.vue";
import RecordTable from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    ImgUpload,
    RecordTable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "资金账号列表", //导出时默认文件名
        apiName:
          "/admin/v3/finance/assetaccount/assetaccountList", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新增",
          method: "addClick",
          permissVal: "admin:finance_assetaccount:addAssetaccount",
        },
        {
          name: "导出",
          method: "exporthandle",
          permissVal: "aaaaa",
        },
        {
          name: "表格设置",
          method: "setTable",
          permissVal: "aaaaa",
        },
        {
          name: "打印",
          method: "printhandle",
          permissVal: "aaaaa",
        },
      ],
      // 更多搜索
      isHaseMore: false,
      dialogTitle: "新建/编辑",
      //  查询框
      baseConfig: [
        {
          type: "input",
          label: "账户名称",
          field: "accountName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "归属部门",
          field: "ids",
          setLabel: "departmentName",
          setValue: "deptId",
          placeholder: "请输入",
          selectOptions: [],
        },
        {
          type: "input",
          label: "管理员工",
          field: "ascriptionUserName",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "账号状态",
          field: "isShow",
          placeholder: "请输入",
          selectOptions: [
            { label: "禁用", val: "0" },
            { label: "启用", val: "1" },
          ],
        },
        {
          type: "select",
          label: "账号类型",
          field: "id",
          placeholder: "请输入",
          selectOptions: [
            { label: "微信账户", val: "wechat:account_status" },
            { label: "支付宝账户", val: "alipay:account_status" },
            { label: "银行账户", val: "bank:account_status" },
          ],
        },
      ],

      queryData: {
        accountName: null,
        ascriptionUserName: null,
        createEndTime: null,
        createStartTime: null,
        isShow: null,
        storageId: null,
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 220,
          Buttons: [
            {
              method: "modifyClick",
              methodName: "修改",
              permissVal: "admin:finance_assetaccount:updateAssetaccount",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:finance_assetaccount:deleteAssetaccount",
            },
            {
              method: "Enable",
              methodName: "启用",
              permissVal: "admin:finance_assetaccount:handleIsShow",
            },
            {
              method: "Forbidden",
              methodName: "禁用",
              permissVal: "admin:finance_assetaccount:handleIsShow",
            },
          ],
        },
        {
          name: "户名",
          field: "accountName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "账号",
          field: "account",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "银行名称",
          field: "accountName",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "开户地址",
          field: "openAddress",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "余额",
          field: "balance",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "所属部门",
          field: "deptName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "管理员工",
          field: "ascriptionUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        // {
        //   name: "是否借支账号",
        //   field: "aaa",
        //   sort: 1,
        //   isShow: true,
        //   isTotal: false,
        //   isSort: false,
        // },
        {
          name: "账号类型",
          field: "accountStatusShow",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "应用类型",
          field: "applicationStatusShow",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "是否默认",
          field: "isDefaultShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "是否启用",
          field: "isShowShow",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "排序",
          field: "sort",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "备注",
          field: "comment",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: false,
        },

        {
          name: "新建时间",
          field: "createTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "新建人",
          field: "createUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "修改时间",
          field: "updateTime",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
        {
          name: "修改人",
          field: "updateUserName",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: false,
        },
      ],
      sortName: "资金账号", //  排序名
      pageGroupName: "FundAccountNo",
      // 新建
      diaWidth: "60%",
      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "户名",
              itemType: "input",
              field: "accountName",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "账号",
              itemType: "input",
              field: "account",
              placeholder: "请输入",
            },
            {
              span: 8,
              title: "银行名称",
              itemType: "input",
              field: "bankName",
              placeholder: "请输入",
            },
            // {
            //   span: 8,
            //   title: "账号",
            //   itemType: "select",
            //   field: "aaa",
            //   placeholder: "请选择",
            //   options: [
            //     {
            //       label: "上楼费",
            //       val: 1,
            //     },
            //     {
            //       label: "验货费",
            //       val: 1,
            //     },
            //     {
            //       label: "加急费",
            //       val: 1,
            //     },
            //   ],
            // },
            // {
            //   span: 8,
            //   title: "核销时间",
            //   itemType: "timeselect",
            //   field: "aaa",
            //   datetype: "datetime",
            //   placeholder: "选择时间",
            // },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "开户地址",
              itemType: "input",
              field: "openAddress",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "归属部门",
              itemType: "select",
              field: "deptId",
              setLabel: "departmentName",
              setValue: "deptId",
              placeholder: "请选择",
              selectOptions: [],
            },
            {
              span: 8,
              title: "管理员工",
              itemType: "select",
              field: "ascriptionUserId",
              setLabel: "name",
              setValue: "documentId",
              placeholder: "请选择",
              options: [],
            },
            {
              span: 8,
              title: "账号类型",
              itemType: "select",
              field: "accountStatus",
              placeholder: "请选择",
              options: [
                { label: "微信账户", val: "wechat:account_status" },
                { label: "支付宝账户", val: "alipay:account_status" },
                { label: "银行账户", val: "bank:account_status" },
              ],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 8,
              title: "应用类型",
              itemType: "select",
              field: "applicationStatus",
              placeholder: "请选择",
              options: [
                { label: "常用资金账户", val: "chang_yong:application_status" },
                { label: "线上微信资金账户", val: "wechat:application_status" },
              ],
            },
            {
              span: 8,
              title: "排序",
              itemType: "input",
              field: "sort",
              placeholder: "请输入",
            },
            {
              span: 8,
              itemType: "checkbox",
              field1: "isDefault",
              field2: "isShow",
            },
          ],
        },

        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "备注",
              itemType: "textarea",
              field: "comment",
              placeholder: "请输入",
            },
          ],
        },
      ],
      baseModel: {
        isShow: false,
        isDefault: false,
      },
      defaultBaseModel: {
        account: null,
        accountName: null,
        accountStatus: null,
        applicationStatus: null,
        ascriptionUserId: null,
        deptId: null,
        isShow: null,
        sort: null,
        comment: null,
        isDefault: null,
        openAddress: null,
        storageId: null,
        bankName: null,
      },

      formRules: {
        account: [{ required: true, message: "请输入账号", trigger: "blur" }],
        sort: [{ required: true, message: "请输入", trigger: "blur" }],
        accountName: [
          { required: true, message: "请输入账户名称", trigger: "blur" },
        ],
        accountStatus: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        applicationStatus: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        ascriptionUserId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        deptId: [{ required: true, message: "请选择", trigger: "change" }],
        isShow: [{ required: true, message: "请选择", trigger: "change" }],
      },
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.GetData();
    this.GetDepts();
    this.GetEmployee();
  },
  methods: {
    // 获取资金账号列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.assetaccountList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          // 缺少字段
          let t = res.data.result?.data?.length || 0;
          if (t > 0) res.data.result.data[0].missField = "missField";
          //
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---资金账号列表`);
        }
      });
    },

    // 获取归属部门
    GetDepts() {
      this.$API.wtl_getDeptList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.diaFormConfig[2].formItem[0].options = result;
          this.baseConfig[1].selectOptions = result;
        }
      });
    },
    // 获取管理员工
    GetEmployee() {
      this.$COMAPI.getObjectUserDownList("employee").then((res) => {
        this.diaFormConfig[2].formItem[1].options = res || [];
      });
    },
    // 获取资金账户详情
    GetAssetaccountIdDetails(id) {
      this.$API.assetaccountDatail({ assetaccountId: id }).then((res) => {
        if (res.data.status === "success") {
          this.baseModel = res.data.result || [];
          this.baseModel.isDefault = Boolean(this.baseModel.isDefault);
          this.baseModel.isShow = Boolean(this.baseModel.isShow);
        }
      });
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },

    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },
    // 导出
    exporthandle() {
      // this.$COMAPI.exportBtn({
      //   pageGroupName: this.pageGroupName, //页面标识
      //   myTableHeard: this.myTableHeard, //表头数组
      //   className: this.className, //列表标识
      //   tableData: this.tableConfig.tableData, //数据源
      //   sheetName: "表名(暂无效)", //表名
      // });
      this.isShowDialog_dc = true;
    },
    //表格设置
    setTable() {
      this.$TOOLS.myModel(this);
    },
    // 打印
    printhandle() {},
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    // 新建
    addClick() {
      this.isShowDialog = true;
    },
    // 修改
    modifyClick(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.GetAssetaccountIdDetails(this.selectTableData[0].assetaccountId);
        this.isShowDialog = true;
      }
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              assetaccountIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.assetaccountIds.push(val.assetaccountId);
            });
            this.$API.deleteAssetaccount(delReq).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.GetData();
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 启用
    Enable(data, t) {
      let title = "启用";
      let isShow = 1;
      if (t == 0) {
        title = "禁用";
        isShow = 0;
      }
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm(`确认${title}所选数据?`, "提示:")
          .then((res) => {
            let params = {
              assetaccountId: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              params.assetaccountId.push(val.assetaccountId);
            });
            params.isShow = isShow;
            // 禁用接口
            this.$API.handleIsShow(params).then((r) => {
              if (r.data.status === "success") {
                this.GetData();
                this.$message.success(r.data.message);
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 禁用
    Forbidden(e) {
      this.Enable(e, 0);
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },

    //  弹窗确认保存事件
    diaConfirmBtn(e) {
      this.$refs["diaform"].$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          this.baseModel.isDefault = Number(this.baseModel.isDefault);
          this.baseModel.isShow = Number(this.baseModel.isShow);
          let param = {};
          for (let key in this.defaultBaseModel) {
            if (this.baseModel[key] || this.baseModel[key] == 0) {
              eval("param." + key + "='" + this.baseModel[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.baseModel.assetaccountId)
            param.assetaccountId = this.baseModel.assetaccountId;

          if (param.assetaccountId) {
            // 修改接口
            this.$API.updateAssetaccount(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addAssetaccount(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 整单核销
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia(e) {
      this.baseModel = { isShow: false, isDefault: false };
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
    },

    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn(e) {
      this.handleCloseDia();
    },
  },
};
</script>
  <style scoped lang="less">
</style>
  